export const VIEWER_TYPES = ['3D', 'Image', '360'] as const;
export type ViewerType = (typeof VIEWER_TYPES)[number];
